// src/Modal.js
import React, { useState, useEffect } from 'react';
import './Modal.css';

const Modal = ({ isOpen, message, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);
  
  // 重置關閉狀態當模態框打開時
  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
    }
  }, [isOpen]);
  
  const handleClose = () => {
    setIsClosing(true);
    // 等待動畫完成後才真正關閉模態框
    setTimeout(() => {
      onClose();
    }, 300);
  };
  
  if (!isOpen) return null;

  return (
    <div className={`modal-overlay ${isClosing ? 'closing' : ''}`} onClick={handleClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <span className="close-button" onClick={handleClose}>&times;</span>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default Modal;